var render = function render(_c, _vm) {
  return !_vm.props.currentRoute.hidden ? _c("a-sub-menu", {
    key: _vm.props.currentRoute.path
  }, [_c("template", {
    slot: "title"
  }, [_vm.props.currentRoute.meta.icon ? _c("svg-icon", {
    attrs: {
      icon: _vm.props.currentRoute.meta.icon
    }
  }) : _vm._e(), _c("menu-title", {
    attrs: {
      title: _vm.props.currentRoute.meta.title
    }
  })], 1), _vm._l(_vm.props.currentRoute.children, function (item) {
    return [!item.children ? _c("menu-item", {
      key: item.path,
      attrs: {
        currentRoute: item,
        customerId: _vm.props.customerId
      }
    }) : _c("sub-menu", {
      key: item.path,
      attrs: {
        currentRoute: item,
        customerId: _vm.props.customerId
      }
    })];
  })], 2) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };